import '../App.css';
import React, { Suspense, useEffect, useState } from 'react';
import Navbar from './Navbar';
import Home from './Home';
import Footer from './Footer';

// Lazy load below-fold sections
const LoginSection = React.lazy(() => import('./LoginSection'));
const FeaturesSection = React.lazy(() => import('./FeaturesSection'));
const InvSection = React.lazy(() => import('./invSection'));
const MonitorSection = React.lazy(() => import('./MonitorSection'));
const ServicesSection = React.lazy(() => import('./ServicesSection'));
const DownloadAppSection = React.lazy(() => import('./DownloadAppSection'));
const InstagramSection = React.lazy(() => import('./InstagramSection'));
const InTouch = React.lazy(() => import('./InTouch'));

import arrowupLogo from "/arrowup.png";

// Scroll to top button
const scrollToTop = () => {
	window.scrollTo({ top: 0, behavior: "smooth" });
};

function HomePage() {

	// REQUIRED: missing state + scroll listener setup
	const [showTopBtn, setShowTopBtn] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 300) {
				setShowTopBtn(true);
			} else {
				setShowTopBtn(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<main className="relative min-h-screen overflow-x-hidden">

			{/* Background Gradient Circle */}
			<div className="absolute -top-28 -left-28 w-[500px] h-[150px] bg-gradient-to-tr 
			from-indigo-500/20 to-pink-500/20 rounded-full blur-[80px] -z-10"></div>

			{/* LCP image preload */}
			<img
				src="/scan_qr.png"
				alt="QR Code"
				className="opacity-0 absolute top-0 left-0 w-0 h-0"
			/>

			<div className="overflow-hidden">

				{/* Sections */}
				<Navbar />
				<Home />
				<LoginSection />
				<FeaturesSection />
				<InvSection />
				<MonitorSection />
				<ServicesSection />
				<DownloadAppSection />
				<InTouch />
				<InstagramSection />
				<Footer />


				{/* Floating QR */}
				<div className="fixed top-1/2 right-6 transform -translate-y-1/2 z-50 flex flex-col items-center">
					<a
						href="/brochure"
						className="w-40 h-50 flex justify-center items-center rounded-lg shadow-md 
						hover:scale-105 transition-transform flex-col animate-float-slow "
						title="Scan to download brochure"
					>
						<img
							src="/scan_qr.png"
							alt="QR Code"
							className="w-32 h-32 border-2 border-gray-300 p-1 rounded"
						/>
						<p className="font-bold text-center text-blue-500 mt-2">
							Brochure <br /> Scan or Click
						</p>
					</a>

      {/* Normal inline CSS for animation */}
      <style>
        {`
          @keyframes float-slow {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
          }
          .animate-float-slow {
            animation: float-slow 2s ease-in-out infinite;
          }
        `}
      </style>				</div>
			</div>

			{/* Scroll-to-top button */}
			{showTopBtn &&
				<button
					onClick={scrollToTop}
					className="fixed bottom-32 left-auto md:bottom-[10%] cursor-pointer 
					right-10 p-8 md:p-6 bg-blue-400 text-white rounded-full shadow-lg 
					hover:bg-blue-500 transition z-500"
					title="Go to top"
				>
					<img src={arrowupLogo} alt="Go up" className="w-6 h-6 filter brightness-0 invert" />
				</button>
			}

		</main>
	);
}

export default HomePage;
